<template>
  <Modal :id="'cmp-booking-booking_list-send_doc_files'" @cancelled="onCancel">
    <template slot="header"> {{ $t("choose_your_template") }} </template>

    <template slot="body">
      <!-- <div class="form-group">
        <Dropdown
          :options="subjects"
          :selected="subjects.find((e) => e.value == selectedSubject)"
          :placeholder="'Subject'"
          box
          v-on:selectedChange="(e) => onSubjectSelect(e)"
        ></Dropdown>
      </div> -->
      <div
        class="dt-list-v2 noteven bb"
        style="
          min-height: 160px;
          max-height: calc(100vh - 300px);
          overflow: auto;
        "
        v-if="templates"
      >
        <div
          class="dt-list--item pad0 ut-curpoint"
          v-for="templ of templates"
          :key="templ.template_id"
          :title="subjectTitle(templ)"
          @click="(e) => onTemplateClick(templ)"
        >
          <div class="dt-list-item--body ut-flex" style="width: 100%">
            <div
              class="dt-list-item--text ut-fc txtov"
              style="width: 100%; overflow: auto"
            >
              <div style="min-height: 28px" class="txtov m-link-2">
                {{ templ.description }}
              </div>
              <div
                style="min-height: 28px"
                class="ut-flex txtov ut-text-secondary"
              >
                {{$t("subject")}}:
                <div
                  style="flex: 1; margin-left: 3px"
                  :class="{
                    'dt-loading shell--v2': subjectLoadingFlag,
                  }"
                >
                  <div
                    style="
                      text-overflow: ellipsis;
                      overflow: hidden;
                      white-space: nowrap;
                      width: 260px;
                    "
                    :style="{
                      color: templ.render_subject == 'ERROR!!! RENDERING TEMPLATE SUBJECT' ? 'red' : 'inherit',
                    }"
                  >
                    {{
                      templ.subject
                        ? templ.render_subject
                          ? templ.render_subject
                          : ".."
                        : $t("no_subject_assigned")
                    }}
                  </div>
                </div>
              </div>
            </div>
            <a href=""></a>
          </div>
        </div>
      </div>
    </template>

    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel"> {{$t('cancel')}} </button>
    </template>
  </Modal>
</template>

<script>
import DetailsTable from "../../../plugins/datatable/datatable";
import InputField from "../../../plugins/text-field/input-field";
import { BookingStoreNamespace as storeNS } from "../store";

import Modal from "../../../dt-plugins/modal/modal";
import { createMailHref, sendMail, waitForAnimation } from "../../../utility";
import { bookingDocumentService } from "../services/booking-details/documents.service";
import { overviewService } from "../services/booking-details/booking-overview.service";
import { BookingService } from "../services/booking-service";
import { mapGetters } from "vuex";
import { createFlatBooking } from "../models/booking-artist.model";
export default {
  components: {
    DetailsTable,
    InputField,
    Modal,
  },
  props: ["emailDetails"],
  mounted: function () {
    if (this.type != "booking_request" && !this.calendar_date_id) {
      throw Error(
        "Pass in a valid Calendar Date id in the Route Param or Query"
      );
    }
    this.getData();
  },
  data: function () {
    return {
      templates: [],

      templateRenders: [],
      documentInvoiceFileData: null,
      // subjects: [],
      // selectedSubject: null,

      templateArgs: this.getDefaultTemplateRenderArgs(),
      calendar_date_json: null,

      subjectLoadingFlag: true,
    };
  },
  computed: {
    ...mapGetters(storeNS, {
      bookingDetails: "bookingDetails",
    }),
    calendar_date_id() {
      return (
        this.$route.params.calendar_date_id ||
        this.$route.query.calendar_date_id
      );
    },
    type: function () {
      return (
        this.$route.query.type ||
        "document_and_files" ||
        "questionnaire" ||
        "booking_request" ||
        "artist_offer"
      );
    },
    insertSendDocumentFilesData() {
      const { document_id, invoice_id, file_relation_id } = this.$route.query;
      return {
        document_id: document_id?.split(",") || "",
        invoice_id: invoice_id?.split(",") || "",
        file_relation_id: file_relation_id?.split(",") || "",
      };
    },
    selectedBookingDetails() {
      const booking = this.bookingDetails[this.calendar_date_id] || {};
      console.log({ booking: booking });
      return booking;
    },
  },
  methods: {
    getDefaultTemplateRenderArgs() {
      return {
        start_date: "",
        booking_location_name: "",
        city: "",
        country: "",
        venue_url: "",
        venue_capacity: "",
        artists: "",
        questionnaire_link: "",
      };
    },
    getData: async function () {
      let docs;
      if (this.type == "document_and_files") {
        const { document_id, invoice_id, file_relation_id } =
          this.insertSendDocumentFilesData;
        console.log({
          "this.insertSendDocumentFilesData": this.insertSendDocumentFilesData,
        });
        this.documentInvoiceFileData =
          await BookingService.insertSendDocumentFiles(
            this.calendar_date_id,
            document_id,
            invoice_id,
            file_relation_id
          ).then((res) => res.data);
        console.log({
          "this.documentInvoiceFileData": this.documentInvoiceFileData,
        });
        docs = await bookingDocumentService.getDocumentTemplate();
      } else if (this.type == "questionnaire") {
        const res = await overviewService.getCalendarDateJSON(
          this.calendar_date_id
        );
        const cdJsonData = res.data;
        this.calendar_date_json = res.data;

        this.templateArgs = {
          start_date: cdJsonData.cdate.start_date,
          booking_location_name: cdJsonData.location.booking_location_name,
          city: cdJsonData.cdate.city,
          country: cdJsonData.cdate.country,
          venue_url: cdJsonData.location.url1,
          venue_capacity: cdJsonData.location.venue_capacity,
          artists: cdJsonData.artist_names,
          questionnaire_link: cdJsonData.shorten_url,
        };

        console.log({ "this.templateArgs": this.templateArgs });

        docs = await bookingDocumentService.getQuestionnairetemplate();
      } else if (this.type == "booking_request") {
        docs = await BookingService.requestFormMail();
      } else if (this.type == "artist_offer") {
        docs = await BookingService.getArtistOffertemplates();
        console.log({ docs: docs });
      }

      this.templates = docs.data.templates;

      this.templates = await Promise.all(
        docs.data.templates.map(async (template) => {
          let render_subject, render_text;
          try {
            ({ render_subject, render_text } = await this.renderTemplate(
              template
            ));
          } catch (error) {
            ({ render_subject, render_text } = {
              render_subject: "ERROR!!! RENDERING TEMPLATE SUBJECT",
              render_text: "ERROR!!! RENDERING TEMPLATE TEXT",
            });
          }
          return {
            ...template,
            render_subject,
            render_text,
          };
        })
      );

      this.subjectLoadingFlag = false;

      console.log({ "this.templates": this.templates });

      // IF only `ONE` custom text template is available in the settings, skip the modal and open up the corresponding mail straight away
      if (this.templates && this.templates.length == 1) {
        this.onTemplateClick(this.templates[0]);
      }

      // docs.data.templates.forEach((element) => {
      //   this.subjects.push(element);
      // });
      // this.
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },
    async renderTemplate(template) {
      console.log({ template: template });
      if (this.type == "document_and_files") {
        const renderedTemplate = await bookingDocumentService.renderTemplate(
          template.template_id,
          this.documentInvoiceFileData.documents,
          this.documentInvoiceFileData.files,
          this.documentInvoiceFileData.invoices,
          template.subject,
          this.documentInvoiceFileData
        );
        return renderedTemplate.data;
      } else if (this.type == "questionnaire") {
        const renderedTemplate =
          await bookingDocumentService.renderQuestionnaireTemplate(
            template.template_id,
            template.subject,
            this.templateArgs
          );
        return renderedTemplate.data;
      } else if (this.type == "booking_request") {
        const renderedTemplate = await BookingService.requestFormMailUrl({
          templateId: template.template_id,
          subject: template.subject,
        });
        return {
          render_subject: template.subject
            ? renderedTemplate.data.render_subject
            : "Booking Request Details",
          render_text: renderedTemplate.data.render_text,
        };
      } else if (this.type == "artist_offer") {
        let renderedTemplate;
        try {
          renderedTemplate = await BookingService.renderArtistOfferTemplate(
            template.template_id,
            template.subject,
            createFlatBooking(
              this.selectedBookingDetails,
              this.$route.query.artist_id
            )
          );
        } catch (e) {}
        return {
          render_subject: template.subject
            ? renderedTemplate?.data?.render_subject
            : "Booking Request Details",
          render_text: renderedTemplate?.data?.render_text,
        };
      }
    },
    onTemplateClick: async function (template) {
      // const { template_id } = template;
      console.log("template", template);

      // console.log("DET EMAILS", this.documentInvoiceFileData);
      // console.log("WWWWWWWWWWWW", template);
      // const renderedTemplate = await bookingDocumentService.renderTemplate(
      //   template.template_id,
      //   this.documentInvoiceFileData.documents,
      //   this.documentInvoiceFileData.files,
      //   this.documentInvoiceFileData.invoices,
      //   template.subject,
      //   this.documentInvoiceFileData
      // );
      // console.log("Rendered template", renderedTemplate);
      // sendMail({
      //   subject: renderedTemplate.data.render_subject,

      //   body: renderedTemplate.data.render_text,
      //   mails: this.documentInvoiceFileData.to.split(","),
      // });

      const { render_subject, render_text, subject } = template;

      console.log("render_text", render_text);

      let mailLink = "";

      if (this.$route.query?.newURL != undefined) {
        const pattern = /(https?:\/\/[^ ]*)/;

        const TextToReplace = render_text.match(pattern);

        console.log(":::::");

        console.log(TextToReplace[0], "replacedText");

        const replacedText = render_text.replace(
          TextToReplace[0],
          this.$route.query?.newURL
        );

        mailLink = createMailHref({
          subject: subject ? render_subject : "",
          body: replacedText,
          mails:
            this.type == "document_and_files"
              ? this.documentInvoiceFileData?.to?.split(",") ?? []
              : [this.calendar_date_json?.promoter?.email1],
        });
      } else {
        mailLink = createMailHref({
          subject: subject ? render_subject : "",
          body: render_text,
          mails:
            this.type == "document_and_files"
              ? this.documentInvoiceFileData?.to?.split(",") ?? []
              : [this.calendar_date_json?.promoter?.email1],
        });
      }

      // console.log({ render_text: render_text });
      window.location = mailLink;

      waitForAnimation(() => {
        this.onCancel();
      });
    },

    subjectTitle(template) {
      return `${template.description}
      \n${this.$t('subject')}: ${
        template.subject ? template.render_subject : this.$t('no_subject_assigned')
      }\n\n\n${template.render_text}`;
    },

    //MARK: Methods
  },
};
</script>

<style lang="scss" scoped>
</style>
